import React, { useState } from 'react';
import FieldSet from 'Components/FieldSet';
import Button from 'Components/Link/Button';
import IconButton from 'Components/Link/IconButton';
import Modal from 'Components/Modal/Modal';
import ModalBody from 'Components/Modal/ModalBody';
import ModalContent from 'Components/Modal/ModalContent';
import ModalFooter from 'Components/Modal/ModalFooter';
import ModalHeader from 'Components/Modal/ModalHeader';
import { icons, sizes } from 'Helpers/Props';

interface SectionFieldSetProps {
  legend: string;
  children: React.ReactNode;
  information?: React.ReactNode;
  informationTitle?: string;
  settings?: React.ReactNode;
  settingsTitle?: string;
}

type OpenModal = 'information' | 'settings' | null;

export default function SectionFieldSet({
  legend,
  children,
  information,
  informationTitle = legend,
  settings,
  settingsTitle = `${legend} Settings`
}: SectionFieldSetProps) {
  const [openModal, setOpenModal] = useState<OpenModal>(null);
  const closeModal = () => setOpenModal(null);
  const modalTitle = openModal === 'settings' ? settingsTitle : informationTitle;
  const modalBody = openModal === 'settings' ? settings : information;

  return <>
    <FieldSet legend={<span className="tdarr-section-legend"><span>{legend}</span><span className="tdarr-section-legend-actions">
      {settings && <IconButton name={icons.SETTINGS} size={15} title={`${legend} settings`} aria-label={`${legend} settings`} onPress={() => setOpenModal('settings')} />}
      {information && <IconButton name={icons.INFO} size={15} title={`About ${legend}`} aria-label={`About ${legend}`} onPress={() => setOpenModal('information')} />}
    </span></span>}>
      {children}
    </FieldSet>
    <Modal isOpen={openModal !== null} size={sizes.MEDIUM} onModalClose={closeModal}>
      <ModalContent onModalClose={closeModal}>
        <ModalHeader>{modalTitle}</ModalHeader>
        <ModalBody>{modalBody}</ModalBody>
        <ModalFooter><Button onPress={closeModal}>Close</Button></ModalFooter>
      </ModalContent>
    </Modal>
  </>;
}
